/* eslint-disable  */
//@ts-nocheck
'use strict';

import React from 'react';

import Autocomplete from './Autocomplete';
import mux from './video-library/mux';
import createClass from 'create-react-class';

const NameAutocomplete = createClass({
  getInitialState() {
    return {
      options: [],
    };
  },
  getOptions(query) {
    return new Promise((resolve, reject) => {
      mux
        .findExerciseInLibrary({ exerciseName: query })
        .then((options) => {
          //console.log('[NameAutocomplete] Fetched autocomplete suggestions.', options);
          resolve(options && options.data);
        })
        .catch((e) => {
          console.log(
            '[NameAutocomplete] Error fetching autocomplete suggestions.',
            e,
          );
          reject(e);
        });
    });
  },
  render() {
    //console.log('[NameAutocomplete] render() called.');
    return (
      <div className="autocompleteContainer">
        <Autocomplete
          value={this.props.value}
          onChange={this.props.onChange}
          getOptions={this.getOptions}
          placeholder={this.props.placeholder}
          maxLength={this.props.maxLength}
          className={this.props.className}
        />
      </div>
    );
  },
});

export default NameAutocomplete;
